module.exports = __webpack_public_path__ + "static/media/logoEstaforHorizontal.5b34012b.jpg";